<template>
  <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
    <ElFormItem label="素材游戏组">
      <el-select v-model="formData.gameGroupId" @change="queryAction" filterable clearable placeholder="全部">
        <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </ElFormItem>

    <ElFormItem label="更新人">
      <ThrottleSelector style="width: 180px" v-model="formData.upOpId" :list="sysUsers" placeholder="全部" filterable clearable />
    </ElFormItem>

    <slot name="parent" :form-data="formData"></slot>

    <ElFormItem>
      <ElInput
        v-model.trim="formData.keyWord"
        placeholder="请输入标签或ID"
        clearable
        style="width: 220px"
        @clear="queryAction"
        @keyup.enter.native="queryAction"
      >
        <i slot="append" @click="queryAction" class="el-icon-search"></i>
      </ElInput>
    </ElFormItem>

    <ElFormItem class="bg-transparent">
      <slot></slot>
    </ElFormItem>
  </ElForm>
</template>

<script setup>
import { ref, computed } from 'vue'
import { initPageData, SYS_USERS, GAME_GROUPS } from '@/data/global-opts'
import ThrottleSelector from '@/components/throttle-select/index.vue'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, GAME_GROUPS])

const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const sysUsers = computed(PAGE_REQUIRED_OPTS.SYS_USERS)

// eslint-disable-next-line
const emits = defineEmits(['query'])

const formData = ref({
  belongType: '',
  gameGroupId: '',
  upOpId: '',
  labelId: '', // slot 标签ID
  keyWord: '',
  level: '',
  aiEnable: ''
})

const queryAction = () => {
  emits('query')
}

// eslint-disable-next-line
defineExpose({
  getForm: () => formData.value
})
</script>

<style scoped lang="scss"></style>
